/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Model_Token_DescriptionInputs */



/**
* | output |
* | --- |
* | "Detailed breakdown of input and output tokens per model" |
*
* @param {Dashboard_Model_Token_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_model_token_description = /** @type {((inputs?: Dashboard_Model_Token_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Model_Token_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Detaillierte Aufschlüsselung der Eingabe- und Ausgabe-Token pro Modell")
	return /** @type {LocalizedString} */ ("Detailed breakdown of input and output tokens per model")
});